import { render, staticRenderFns } from "./TableItmes.vue?vue&type=template&id=cfc9df68&"
import script from "./TableItmes.vue?vue&type=script&lang=js&"
export * from "./TableItmes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VIcon,VSimpleTable,VTreeview})
